/** TradeStation stream quote field names (canonical backend contract). */
export const TS_QUOTE_FIELDS = [
  'Symbol',
  'Last',
  'Bid',
  'Ask',
  'Open',
  'High',
  'Low',
  'Close',
  'PreviousClose',
  'NetChange',
  'NetChangePct',
  'Volume',
  'BidSize',
  'AskSize',
  'LastSize',
  'TradeTime',
  'QuoteTime',
];

/** Pick quote fields for inspection — only values present on the object; no cross-field fallbacks. */
export function pickQuoteFields(quote, { symbol } = {}) {
  if (!quote) return null;
  const out = {};
  if (symbol) out.Symbol = symbol;
  for (const key of TS_QUOTE_FIELDS) {
    if (key === 'Symbol') continue;
    const value = quote[key];
    if (value != null && value !== '') out[key] = value;
  }
  if (!out.Symbol && quote.Symbol) out.Symbol = quote.Symbol;
  return Object.keys(out).length > 0 ? out : null;
}
